const COOKIE_AUTH_TOKEN = 'token';
const COOKIE_FEATURE_FLAGS = 'featureFlag';

// Feature flags index positions (auto-increment)
enum FeatureTags {
  MUED_IS_FOLD = 0,
  AI_IS_FIRST_VISIT = 1,
  SHOPPING_HELP_IS_FIRST_VISIT = 2,
}

export {
  COOKIE_AUTH_TOKEN,
  COOKIE_FEATURE_FLAGS,
  FeatureTags,
};
